import { render, staticRenderFns } from "./insertionModal2.vue?vue&type=template&id=c0a1e8dc&"
import script from "./insertionModal2.vue?vue&type=script&lang=ts&"
export * from "./insertionModal2.vue?vue&type=script&lang=ts&"
import style0 from "./insertionModal2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports